import { Alert, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router-dom'
import type { SaasApiError } from '../../api'
import { loadVirtualIpWorkflowFacts } from './loadVirtualIpWorkflowFacts'
import { virtualIpProjectsPath } from './virtualIpPaths'
import { virtualIpResumePath } from './virtualIpProgress'

/** Project index: resolve server progress → navigate to resumable step / summary. */
export default function VirtualIpResumeRedirect() {
  const { t } = useTranslation(['virtualIp', 'actions', 'status', 'validation'])

  const { workspaceId = '', projectId = '' } = useParams()
  const [target, setTarget] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!workspaceId || !projectId) return
    let cancelled = false
    loadVirtualIpWorkflowFacts(workspaceId, undefined, projectId)
      .then((facts) => {
        if (cancelled) return
        setTarget(virtualIpResumePath(workspaceId, facts.progress, projectId))
      })
      .catch((e) => {
        if (!cancelled) setError((e as SaasApiError).message || t('common.resumeFailed'))
      })
    return () => {
      cancelled = true
    }
  }, [workspaceId, projectId, t])

  if (!projectId) {
    return <Navigate to={virtualIpProjectsPath(workspaceId)} replace />
  }

  if (error) {
    return (
      <div className="tc-vip-page">
        <Alert type="error" showIcon message={t('common.resumeEntryFailed')} description={error} />
      </div>
    )
  }
  if (!target) {
    return (
      <div className="tc-vip-page" data-testid="virtual-ip-resume-loading">
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>
    )
  }
  return <Navigate to={target} replace />
}
